<div
    class="map-mode-wrapper"
    [ngClass]="{ 'dropdown-expanded': expanded, 'left-sidebar-open': leftSidebarVisible(), 'right-sidebar-open': rightSidebarVisible() }"
>
    @if (initialMapModeChosen$ | async) {
    <div class="map-mode-bar">
        <div class="big-screen">
            <!-- TODO: Remove everything with the mapmode.Market when everything is working -->
            <!-- <div class="mode-btn first market"
                [class.selected]="formControl.value === mapMode.Market" 
                (click)="chooseOption(mapMode.Market)">
                    <div class="house-icon"></div>
                    <div class="category-name">
                        <div class="title">Bolig</div>
                        <div class="sub-title">
                            <div class="name">Salg</div>
                        </div>
                    </div>

                    <ev-tooltip-simple class="tooltip market" text="Dette kartet gir deg oversikt over boligmarkedet for alle generelle boligtyper, inkludert fritidsbolig, og tomter."></ev-tooltip-simple>
            </div> -->
                <div class="mode-btn first market"
                [class.selected]="formControl.value === mapMode.Market2" 
                (click)="chooseOption(mapMode.Market2)">
                    <div class="house-icon"></div>
                    <div class="category-name">
                        <div class="title">Bolig</div>
                        <div class="sub-title">
                            <div class="name">Salg</div>
                        </div>
                    </div>

                    <ev-tooltip-simple class="tooltip market" text="Dette kartet gir deg oversikt over boligmarkedet for alle generelle boligtyper, inkludert fritidsbolig, og tomter."></ev-tooltip-simple>
            </div>
            <div class="mode-btn properties" 
                [class.selected]="formControl.value === mapMode.Properties"
                [class.disabled]="!roles.hasViewEstatesInViewRole"
                (click)="chooseOption(mapMode.Properties)">
                    <div class="house-icon"></div>
                    <div class="category-name">
                        <div class="title">Bolig</div>
                        <div class="sub-title">
                            <div class="name">Eiendom</div>
                            <div class="order">Bestill</div>
                        </div>
                    </div>

                    <ev-tooltip-simple class="tooltip properties" text="Dette kartet gir deg oversikt over alle generelle boligtyper og tomter."></ev-tooltip-simple>
            </div>
            <div class="mode-btn new-dwellings" 
                [class.selected]="formControl.value === mapMode.NewDwellings"
                [class.disabled]="!roles.hasNewDwellingsRole"
                (click)="chooseOption(mapMode.NewDwellings)">
                    <div class="house-icon"></div>
                    <div class="category-name">
                        <div class="title">Bolig</div>
                        <div class="sub-title">
                            <div class="name">Nybygg</div>
                            <div class="order">Bestill</div>
                        </div>
                    </div>

                    <ev-tooltip-simple class="tooltip new-dwellings" text="Dette kartet gir deg oversikt over alle nybyggsprosjekter, både pågående og historiske."></ev-tooltip-simple>
            </div>
            <div class="mode-btn commercial-sale last" 
                [class.selected]="formControl.value === mapMode.CommercialSale"
                [class.disabled]="!roles.hasCommercialRole"
                (click)="chooseOption(mapMode.CommercialSale)">
                    <div class="house-icon commercial"></div>
                    <div class="category-name">
                        <div class="title">Næring</div>
                        <div class="sub-title">
                            <div class="name">Salg</div>
                            <div class="order">Bestill</div>
                        </div>
                    </div>

                    <ev-tooltip-simple class="tooltip commercial-sale" text="Dette kartet gir deg oversikt over næringsmarkedet, inkludert landbruk."></ev-tooltip-simple>
            </div>
        </div>
        
        <div class="small-screen">
            <div class="category">
                <div class="category-header" (click)="dropdownClicked()">
                    <span
                        class="house-icon"
                        [ngClass]="{
                            estate:
                                formControl.value === mapMode.Market || formControl.value === mapMode.Properties || formControl.value === mapMode.NewDwellings,
                            commercial: formControl.value === null || formControl.value === mapMode.CommercialSale
                        }"
                    ></span>
                    @if (formControl.value === mapMode.Market || formControl.value === mapMode.Properties || formControl.value === mapMode.NewDwellings) {
                    <span class="category-name hide-smallest-screen">Bolig</span>
                    } @else if (formControl.value !== null && formControl.value === mapMode.CommercialSale) {
                    <span class="category-name hide-smallest-screen">
                        <div>Næring</div>
                    </span>
                    }
                    <span>{{ stringValues[formControl.value] }}</span>
                    <span class="dropdown-icon"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="dropdown">
        <div class="category">
            <div class="header">
                <span class="house-icon"></span>
                <span class="category-name">Bolig</span>
            </div>
            <ul class="options">
                <!-- TODO: cleanup when everything is working -->
                <!-- <li class="option">
                    <input type="radio" id="estateSale" [value]="mapMode.Market" [formControl]="formControl" (click)="chooseOption(mapMode.Market)" />
                    <label for="estateSale">Salg</label>
                </li> -->
                <li class="option">
                    <input type="radio" id="estateSale" [value]="mapMode.Market" [formControl]="formControl" (click)="chooseOption(mapMode.Market2)" />
                    <label for="estateSale">Salg</label>
                </li>
                @if(roles.hasDebugRole) {
                <li class="option">
                    <input type="radio" id="estateSale2" [value]="mapMode.Market2" [formControl]="formControl" (click)="chooseOption(mapMode.Market2)" />
                    <label for="estateSale2">Salg
                        <div class="beta-tag">Beta</div>
                    </label>
                </li>
                }
                @if (roles.hasViewEstatesInViewRole) {
                <li class="option">
                    <input
                        type="radio"
                        id="estateProperty"
                        [value]="mapMode.Properties"
                        [formControl]="formControl"
                        (click)="chooseOption(mapMode.Properties)"
                    />
                    <label for="estateProperty">Eiendom</label>
                </li>
                } @else {
                <li class="option disabled" (click)="chooseOption(mapMode.Properties)">
                    <span class="name">Eiendom</span>
                    <span class="order">Bestill</span>
                </li>
                } @if (roles.hasNewDwellingsRole) {
                <li class="option">
                    <input
                        type="radio"
                        id="estateNewDwelling"
                        [value]="mapMode.NewDwellings"
                        [formControl]="formControl"
                        (click)="chooseOption(mapMode.NewDwellings)"
                    />
                    <label for="estateNewDwelling">Nybygg</label>
                </li>
                } @else {
                <li class="option disabled" (click)="chooseOption(mapMode.NewDwellings)">
                    <span class="name">Nybygg</span>
                    <span class="order">Bestill</span>
                </li>
                }
            </ul>
        </div>
        <div class="category commercial">
            <div class="header">
                <span class="house-icon commercial"></span>
                <span class="category-name">
                    <div>Næring</div>
                </span>
            </div>
            <ul class="options">
                @if (roles.hasCommercialRole) {
                <li class="option">
                    <input
                        type="radio"
                        id="commercialSale"
                        [value]="mapMode.CommercialSale"
                        [formControl]="formControl"
                        (click)="chooseOption(mapMode.CommercialSale)"
                    />
                    <label for="commercialSale">Salg</label>
                </li>
                } @else {
                <li class="option disabled" (click)="chooseOption(mapMode.CommercialSale)">
                    <span class="name">Salg</span>
                    <span class="order">Bestill</span>
                </li>
                }
            </ul>
        </div>
    </div>
    }
    <ev-dialog
        [visible]="showMissingRoleDialog"
        [title]="missingRoleTitle"
        [hideCancel]="true"
        (confirm)="closeMissingRoleDialog()"
        (close)="closeMissingRoleDialog()"
        [confirmText]="'Lukk'"
        [maxWidth]="'460px'"
    >
        <p class="dialog-content-text">Du abonnerer ikke på denne tjenesten.<br />For mer informasjon og bestilling, kontakt Eiendomsverdi.</p>
    </ev-dialog>
</div>
